import React, { useContext } from 'react';
import { isEmpty } from 'lodash';
import { observer } from 'mobx-react-lite';
import { JobPostingContext } from '../../../contexts/JobPostingContext';
import { JobPostingFormElement } from './JobPostingFormElement';

export const EditableJobPostingField = observer(
  (
    {
      jpKey,
      children,
      className,
      label,
      type,
      options,
      errorText,
      maxLength,
      required
    }) => {
    const { editorModeActive, activeJobPosting } = useContext(JobPostingContext);

    if (editorModeActive || type === 'rte') {
      return (
        <JobPostingFormElement
          value={activeJobPosting[jpKey]}
          {...{
            label,
            type,
            options,
            jpKey,
            errorText,
            maxLength,
            required
          }}
        />
      );
    }
    return (
      <div key={jpKey}>
        {!isEmpty(children) ? (
          children
        ) : (
          <p data-testid={`job-posting-static-${jpKey}`} className={className}>
            {activeJobPosting[jpKey]}
          </p>
        )}
      </div>
    );
  }
);
